import { ColumnType } from 'antd/es/table';
import { ComplianceCategories } from '@ui/icons';
import { COPY_SPECIFIC } from '@sonar-software/sonar-ts-constants';
import { getAccessObjectColumns } from '../columns/AccessObjectColumns';
import React from 'react';

import { AccessExplainerField, AccessObject, AccessType, DataSensitivityLevelId } from '@sonar-software/sonar-core';
import { DataSensitivityLevelTag, FieldUsageTag } from '@ui/tags';

type ColumnDefinition = ColumnType<AccessExplainerField>;

const fieldNameColumn: ColumnDefinition = {
	dataIndex: 'fieldName',
	fixed: 'left',
	key: 'fieldName',
	title: COPY_SPECIFIC.FIELD,
	width: 160
};

const complianceCategoryColumn: ColumnDefinition = {
	align: 'center',
	dataIndex: 'complianceCategory',
	key: 'complianceCategory',
	render: (complianceCategory: number) =>
		<ComplianceCategories categoryFlags={ complianceCategory } />,
	title: COPY_SPECIFIC.COMPLIANCE_CATEGORY,
	width: 120
};

const fieldUsageColumn: ColumnDefinition = {
	align: 'center',
	dataIndex: 'fieldUsageId',
	key: 'fieldUsageId',
	render: (fieldUsageId: number) =>
		<FieldUsageTag fieldUsageId={ fieldUsageId } />,
	title: COPY_SPECIFIC.FIELD_USAGE,
	width: 100
};

const sensitivityColumn: ColumnDefinition = {
	align: 'center',
	dataIndex: 'dataSensitivityLevelId',
	key: 'dataSensitivityLevelId',
	render: (dataSensitivityLevelId: number) =>
		<DataSensitivityLevelTag dataSensitivityLevelId={ dataSensitivityLevelId as DataSensitivityLevelId } />,
	title: COPY_SPECIFIC.SENSITIVITY,
	width: 105
};

export function getColumns(
	dynamicColumns: Record<string, AccessObject>,
	highlightDifferences: boolean,
	additionalColumnIds?: Array<string>,
	onAddPermissionObject?: (label: string, type: AccessType, value: string) => void,
	onRemovePermissionObject?: (accessKey: string) => void
): Array<ColumnDefinition> {
	const columns = getAccessObjectColumns<AccessExplainerField>('field',
		dynamicColumns,
		highlightDifferences,
		additionalColumnIds,
		onAddPermissionObject,
		onRemovePermissionObject);

	return [
		fieldNameColumn,
		complianceCategoryColumn,
		fieldUsageColumn,
		sensitivityColumn,
		...columns
	];
}
